import { Component } from '@angular/core';
import { BODY, H2, H3, LEAD, SECTION_INNER, SECTION_PAD } from '../../shared/ui';
import { OffersPreviewComponent } from '../previews/offers-preview.component';

interface ProcessStep {
  title: string;
  description: string;
}

@Component({
  selector: 'app-process-v3',
  standalone: true,
  imports: [OffersPreviewComponent],
  templateUrl: './process-v3.component.html',
})
export class ProcessV3Component {
  readonly inner = SECTION_INNER;
  readonly pad = SECTION_PAD;
  readonly h2 = H2;
  readonly h3 = H3;
  readonly lead = LEAD;
  readonly body = BODY;

  // Titles from v2; descriptions shortened, no new claims.
  readonly steps: readonly ProcessStep[] = [
    { title: 'Submit Request', description: "Outline your client's needs and preferred credit solution criteria." },
    { title: 'Automated Outreach', description: 'The request goes to our network of vetted lenders for review.' },
    { title: 'Receive Term Options', description: 'Lenders respond with up to three tailored options, typically within 24 hours.' },
    { title: 'Select and Advance', description: 'Choose the option that fits and move into the next phase of the loan.' },
  ];
}
